const normalizePresetSettings = (presetSettings = {}) => ({
  ...presetSettings,
  notProofingDescriptionShow: presetSettings.notProofingDescriptionShow ?? true,
  notProofingTitleShow: presetSettings.notProofingTitleShow ?? true,
});

export default normalizePresetSettings;
